<template>
  <v-dialog v-model="dialog" persistent scrollable width="600px" @keydown.esc="hide">
    <v-form>
      <v-card>
        <v-card-title class="card-panel blue lighten-3">Режим &laquo;План / Факт&raquo;</v-card-title>

        <v-card-text class="mt-2">
          <p>Режим <b>план / факт</b> предназначен для активностей, по которым фактически оказанные услуги не совпадают с отраженными в документах (когда изменения в контракт внести невозможно).</p>
          <p>После включения этого режима цена и информация о размещении для каждого юнита становится независимой, поэтому чтобы не вносить данные о размещении два раза включайте этот режим как можно позже и отметьте галку "Скопировать текущие данные".</p>

          <v-checkbox
            v-model="form.copy"
            label="Скопировать текущие данные «Факт» в «План»"
            hide-details
            class="mt-2"/>
        </v-card-text>
        <v-divider/>

        <v-card-actions>
          <v-btn raised @click="hide">Отмена</v-btn>
          <v-spacer></v-spacer>
          <v-btn type="submit" raised color="primary" :loading="loading" @click.prevent="submitAction">Включить</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script type="text/javascript">
import api from '@/api'

export default {
  props: [ 'activity' ],
  data: () => ({
    stamp: 0,
    dialog: false,
    loading: false,
    form: {}
  }),
  methods: {
    open () {
      if ( +this.activity.activityIsPlan ) return
      this.form = {}
      this.dialog = true
    },
    hide () {
      this.dialog = false
    },
    submitAction() {
      this.loading = true
      api.post('activities/enablePlan/'+this.activity.activityID, form).then(response => {
        this.loading = false
        if ( response.data.$result !== 'ok' ) return this.$root.$alert(response.data.data, true)
        this.hide()
        this.$emit('set')
        this.$emit('updated')
      }).catch(error => (this.loading = false, this.$root.$alert(error, true)) )
    }
  }
}
</script>

<style type="text/css">
.editable { cursor: pointer; }
.editable:hover { color: #08A2B8 !important; border-bottom: 1px #08A2B8 dashed; }

</style>
